import { useCallback, useContext } from 'react';
import { useActiveBrandIdentifier } from '@trinity/chat-components/containers/UserBrands/useActiveBrandIdentifier';
import { ChatStateDispatchContext } from '../../Chat.State/context';
import { ChatContextItemsContext } from '../context';
import {
  type OpenNewChatForSubjectPayload,
  createOpenNewChatForSubjectStateAction,
} from '../utils/open-new-chat-for-subject';

export function useOpenNewChatForSubjectAction(): (payload: OpenNewChatForSubjectPayload) => boolean {
  const dispatch = useContext(ChatStateDispatchContext);
  const contextItems = useContext(ChatContextItemsContext);
  const brandIdentifier = useActiveBrandIdentifier();

  return useCallback(
    (payload: OpenNewChatForSubjectPayload): boolean => {
      if (!brandIdentifier) {
        return false;
      }

      const stateAction = createOpenNewChatForSubjectStateAction({
        brandIdentifier,
        contextItems,
        payload,
      });

      if (!stateAction) {
        return false;
      }

      dispatch(stateAction);
      return true;
    },
    [brandIdentifier, contextItems, dispatch]
  );
}
